<div class="row grid-row">
    <!-- <div class="col-md-2 col-sm-1 clickable  grid-column">
  <div    (click)="onCodeClick($event)">
    <i  *ngIf="isMasked" class="fa fa-lock" container="body" placement="bottom" [tooltip]="maskTooltip"  (click)="onToggleViewCoupon($event)" ></i>
    <i *ngIf="!isMasked" class="fa fa-unlock" container="body" placement="bottom" [tooltip]="maskTooltip"  (click)="onToggleViewCoupon($event)"></i>

    <span  class="font-weight-bold">{{code}}</span>
  </div>

  <ng-template #maskTooltip>{{'CouponsList.MaskExplanation' | translate}} </ng-template>
</div>   -->

    <div class="col-md-1 col-sm-1 clickable grid-column">
        <div
            (click)="onCodeClick($event)"
            (mouseover)="onUnmask()"
            (mouseleave)="onMask()"
        >
            <span class="font-weight-bold">
                <span>{{ code }}</span>
            </span>
        </div>
    </div>

    <div class="col-md-1 col-sm-1 grid-column pr-0" hznTestId="coupon-row-type">
        {{ translateType(item) }}
    </div>

    <div class="col-md-1 col-sm-1 grid-column">
        @if (isAmount) {
            <div>{{ item.value | amount: 0 }}</div>
        }
        @if (isPercent) {
            <div>{{ item.value }}%</div>
        }
        @if (isWeeks) {
            <div>{{ item.value }}w</div>
        }
        @if (isDays) {
            <div>{{ item.value }}d</div>
        }
    </div>
    <div class="col-md-1 col-sm-1 grid-column" hznTestId="coupon-row-usage-type">
        {{ translateUsageType(item) }}
    </div>
    <div class="col-md-2 col-sm-1 grid-column" hznTestId="coupon-row-status">{{ translateStatus(item) }}</div>
    <div class="col-md-1 col-sm-1 grid-column" hznTestId="coupon-row-category">{{ item.category?.name }}</div>
    <div class="col-md-2 col-sm-1 grid-column" hznTestId="coupon-row-sent-to">{{ item.sentTo }}</div>
    <div class="col-md-1 col-sm-1 grid-column">
        {{ item.validFrom | bcDate: "MMM DD" }}
    </div>
    <div class="col-md-1 col-sm-1 grid-column">
        {{ item.validTo | bcDate: "MMM DD" }}
    </div>
    <div class="col-md-1 col-sm-1 grid-column">
        @if (showActivate) {
            <button
                [bcShowIfPrivilegeDynamic]="'Camps.campsCanManageCoupons'"
                class="btn btn-action btn-outline-success"
                hznTestId="coupon-row-activate"
                (click)="onActivate($event)"
            >
                {{ "CouponsList.Activate" | translate }}
            </button>
        }
        @if (showDeactivate) {
            <button
                [bcShowIfPrivilegeDynamic]="'Camps.campsCanManageCoupons'"
                class="btn btn-action btn-outline-success"
                hznTestId="coupon-row-deactivate"
                (click)="onDeactivate($event)"
            >
                {{ "CouponsList.Deactivate" | translate }}
            </button>
        }
    </div>
</div>
